"use client";
import { Button as JoyBtn } from "@mui/joy";

export default function Button(props: any) {
    const sx = {
        borderRadius: "var(--std-border-radius)",
        fontWeight: "500",
        border: "1px solid",
        borderColor: "divider",
    };
    return <JoyBtn sx={sx} {...props} />;
}
